<template>
<div>
    <div :class="is_nested ? 'form-submission-card-content-child-item' : 'form-submission-card-content-child'">
        <response-question :question="question" />
        <response-options :answer="answer" />
        <response-option-free-text
            v-for="answer_option in answer.answer_options"
            :key="answer_option.id"
            :answer="answer_option.answer"
        />
    </div>

    <response-text
        v-if="answer.question.type === 'checkbox_other' && answer.answer"
        question="Other"
        :answer="answer?.answer"
        is_nested
    />
</div>
</template>

<script>
import ResponseQuestion from "./ResponseQuestion.vue";
import ResponseOptions from "./ResponseOptions.vue";
import ResponseOptionFreeText from "./ResponseOptionFreeText.vue";
import ResponseText from "./ResponseText.vue";

export default {
    components: {
        ResponseQuestion,
        ResponseOptions,
        ResponseOptionFreeText,
        ResponseText,
    },
    props: {
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: Object,
            required: true,
        },
        is_nested: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
